import React, { useState } from "react"
import styled from "styled-components"
import Chevron from "./svg/chevron"
import ItineraryBox from "./itinerary-box"
import PropTypes from "prop-types"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 70px;
  padding-bottom: 64px;

  @media (max-width: 600px) {
    padding-bottom: 0;
  }
`

const Title = styled.div`
  color: ${props => props.theme.blackShade};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0.5px;
  margin-bottom: 32px;
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`
// const Download = styled.div`
//   color: ${props => props.theme.secondary800};
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 700;
//   line-height: 24px;
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   cursor: pointer;
// `

const Expand = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  & svg {
    transition: all 0.2s;
    transform: rotate(${props => (props.$expandAll ? "180deg" : "0deg")});
  }
`

const CardHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 600px) {
    gap: 0;
  }
`

const DayByDay = ({ itinerary }) => {
  const [expandAll, setExpandAll] = useState(false)
  return (
    <Wrapper id="itinerary">
      <Title>Day by day itinerary</Title>
      <Row>
        {/* <Download>
          <DownloadIcon />
          Download itinerary
        </Download> */}
        <Expand onClick={() => setExpandAll(!expandAll)} $expandAll={expandAll}>
          {expandAll ? "Collapse all days" : "Expand all days"} <Chevron />
        </Expand>
      </Row>
      <CardHolder>
        {itinerary.map(day => (
          <ItineraryBox key={day.label} itinerary={day} expandAll={expandAll} />
        ))}
      </CardHolder>
    </Wrapper>
  )
}

DayByDay.propTypes = {
  itinerary: PropTypes.array,
}
export default DayByDay

// const DownloadIcon = () => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="16"
//       height="16"
//       viewBox="0 0 16 16"
//       fill="none"
//     >
//       <path
//         d="M6.58564 12.0813C7.36646 12.8627 8.63277 12.8631 9.41408 12.0822C9.41439 12.0819 9.41468 12.0817 9.41499 12.0813L11.5556 9.94069C11.8026 9.66759 11.7814 9.246 11.5083 8.99906C11.254 8.76916 10.8668 8.76956 10.613 9L8.66233 10.9513L8.66699 0.666687C8.66696 0.298469 8.36849 0 8.0003 0C7.63211 0 7.33364 0.298469 7.33364 0.666656L7.32764 10.9387L5.38764 9C5.12714 8.73969 4.70496 8.73984 4.44464 9.00034C4.18433 9.26084 4.18449 9.68303 4.44499 9.94334L6.58564 12.0813Z"
//         fill="#2B4346"
//       />
//       <path
//         d="M15.3333 10.6667C14.9652 10.6667 14.6667 10.9651 14.6667 11.3333V14C14.6667 14.3682 14.3682 14.6667 14 14.6667H2C1.63181 14.6667 1.33334 14.3682 1.33334 14V11.3333C1.33334 10.9652 1.03487 10.6667 0.666687 10.6667C0.298469 10.6667 0 10.9652 0 11.3333V14C0 15.1046 0.895437 16 2 16H14C15.1046 16 16 15.1046 16 14V11.3333C16 10.9652 15.7015 10.6667 15.3333 10.6667Z"
//         fill="#2B4346"
//       />
//     </svg>
//   )
// }
